import React, { ReactNode } from 'react';

import 'components/Modals/CommonModal/CommonModal.scss';

type ModalType = {
  showModal: boolean;
  closeModal: () => void;
  children: ReactNode;
};

export const CommonModal = ({ showModal, closeModal, children }: ModalType) => {
  if (!showModal) return null;

  return (
    <>
      {showModal && (
        <div className="box">
          <div className="container" onClick={closeModal} />
        </div>
      )}
      <div className="box">{children}</div>
    </>
  );
};
